module.exports = __webpack_public_path__ + "img/register.cfd9ef09.jpg";